function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import * as R from 'unitx/ramda';
// @ts-ignore
// export const withTheme: <Props extends {
//   theme?: ReactNativePaper.Theme;
// }, C>(WrappedComponent: (import('react').ComponentClass<Props, any> & C) | (import('react').FunctionComponent<Props> & C)) => (import('react').ComponentClass<Pick<Props, Exclude<keyof Props, 'theme'>> & {
//   theme?: import('@callstack/react-theme-provider').$DeepPartial<ReactNativePaper.Theme> | undefined;
// }, any> & import('@callstack/react-theme-provider/typings/hoist-non-react-statics').NonReactStatics<(import('react').ComponentClass<Props, any> & C) | (import('react').FunctionComponent<Props> & C), {}>) | (import('react').FunctionComponent<Pick<Props, Exclude<keyof Props, 'theme'>> & {
//   theme?: import('@callstack/react-theme-provider').$DeepPartial<ReactNativePaper.Theme> | undefined;
// }> & import('@callstack/react-theme-provider/typings/hoist-non-react-statics').NonReactStatics<(import('react').ComponentClass<Props, any> & C) | (import('react').FunctionComponent<Props> & C), {}>) = defaultWithTheme
import { useTheme as defaultUseTheme } from "../_/@ui-kitten/components";
export { LightTheme as DefaultTheme } from "./LightTheme";
export { DarkTheme } from "./DarkTheme";
export { Mapping as DefaultMapping } from "./Mapping";
export { ThemeProvider } from "../_/@ui-kitten/components";
export const useTheme = defaultUseTheme;
export const withTheme = Component => /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Component // @ts-ignore
  , _extends({
    ref: ref,
    theme: theme
  }, props));
});
export const matchColorMap = ( // @ts-ignore
colorMap = {}, theme) => R.mapObjIndexed( // @ts-ignore
color => {
  var _theme$colors$color;

  return (_theme$colors$color = theme.colors[color]) !== null && _theme$colors$color !== void 0 ? _theme$colors$color : color;
})(colorMap);
export { Theme } from "../type"; // export { mapping as DefaultMapping } from '@eva-design/eva'